import { Component, OnInit } from '@angular/core';
import "./weather-forecast.component.scss";
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import localeNn from '@angular/common/locales/nn';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeNn);

@Component({
  selector: 'weather-forecast',  
  templateUrl: './weather-forecast.component.html'
})

export class WeatherForecastComponent implements OnInit {
  
  yrError: boolean = false;
  yrToday: any;
  yrTomorrow: any;
  yrTop: boolean = true;
  yrTimeout: any;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.fetchYr();
  }

  fetchYr() {
    this.http.get(this.yrTop ? "/api/yr?top" : "/api/yr").subscribe(
      (yr) => {
          if (!yr['forecast'] || !yr['forecast']['tabular'] || !yr['forecast']['tabular']['time'])
            return this.setYrError();

          this.yrToday = yr['forecast']['tabular']['time'].find(t  => parseInt(t.period) >= 2);
          this.yrTomorrow = yr['forecast']['tabular']['time'].find(t => parseInt(t.period) == 2 && t != this.yrToday);
          this.yrError = false;

          
          this.yrTimeout = setTimeout( () => {
              this.fetchYr();
          }, (moment.utc(yr['meta']['nextupdate']).unix() - moment.utc().unix()) * 1000);
      },
      
      () => {
          this.setYrError();
    });
  }

  setYrError() {
    this.yrError = true;

    this.yrTimeout = setTimeout( () => {
      this.fetchYr();
    }, (1 * 60 * 1000));
  }

  toggleYrTop() {
    this.yrTop = !this.yrTop;
    clearTimeout(this.yrTimeout);
    this.fetchYr();
  }
}